import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import './RichText.css';
import React, { useState } from 'react';
import { parse } from 'node-html-parser';
import { RichText as SitecoreRichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumCheckRightTextClick, tealiumMergeClickData } from '../../utils/tealium';
import { renderRTListSchema, getListsTexts } from '../../utils/seo';
// import fadeImg from '../../resources/img/transparent.png';

import { convertToAnalyticObject } from '../../utils/analytics';
export var scrollLazyLoad = function scrollLazyLoad() {
  var images = document.getElementsByClassName('img-lazy-load');
  if (images && images.length) {
    var bottomPos = document.documentElement.scrollTop + window.innerHeight;
    var _iterator = _createForOfIteratorHelper(images),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var img = _step.value;
        if (img.getBoundingClientRect().y) {
          console.info('lazy working');
          if (img.getBoundingClientRect().y < bottomPos) {
            img.classList.remove('img-lazy-load');
            img.setAttribute('src', img.getAttribute('data-src'));
          }
        } else {
          console.info('lazy not working');
          img.classList.remove('img-lazy-load');
          img.setAttribute('src', img.getAttribute('data-src'));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
export var checkIE = function checkIE() {
  if (canUseDOM) {
    var ua = window.navigator.userAgent,
      msie = ua.indexOf("MSIE");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      return true;
    }
  }
  return false;
};
export var parsedHtml = function parsedHtml(copy, isIE) {
  var elem = document.createElement('div');
  elem.innerHTML = copy;
  var images = elem.getElementsByTagName('img');
  var paramsToAdd = '?&cx=0.5&cy=0.5&cw=1200';
  for (var i = 0; i < images.length; i++) {
    if (images[i].width && images[i].width > 1200) {
      var imgSrc = images[i].src;
      imgSrc = imgSrc + paramsToAdd;
      images[i].src = imgSrc;
    }
    if (!isIE) {
      images[i].classList.add('img-lazy-load');
      images[i].setAttribute('data-src', images[i].src);
      images[i].setAttribute('src', '');
    }
  }
  return {
    images: images.length,
    output: elem.innerHTML
  };
};
var RichText = function RichText(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var firstColumn = params !== undefined && params['Position'] === 'First Column' ? true : false;
  var center = params !== undefined && params['Position'] === 'Center Align' ? true : false;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    output = _useState2[0],
    setOutput = _useState2[1];
  var richtextRef = React.useRef();
  var readMoreLabel = get(fields, 'richTextSettings.fields.readMoreLabel.value');
  var isExpandable = get(fields, 'isExpandable.value');
  var textValue = get(fields, 'text.value', '');
  var _useState3 = useState(isExpandable),
    _useState4 = _slicedToArray(_useState3, 2),
    textHidden = _useState4[0],
    setTextHidden = _useState4[1];
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    componentListsSchema = _React$useState2[0],
    setComponentListsSchema = _React$useState2[1];

  // #20991
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }

  // #20991
  React.useEffect(function () {
    if (fields && fields.text) {
      var isIE = checkIE();
      if (canUseDOM) {
        var obj = parsedHtml(fields && fields.text && fields.text.value, isIE);
        setOutput(obj.output);
        if (obj.images && !isIE) {
          setTimeout(function () {
            scrollLazyLoad();
            window.addEventListener('scroll', scrollLazyLoad);
          }, 1);
        }
      }
    }
    if (richtextRef.current) {
      richtextRef.current.classList.remove('height-fix');
    }
  }, [textValue]);
  React.useEffect(function () {
    var dom = parse(textValue);
    var rtLists = getListsTexts(dom);
    if (rtLists.length) setComponentListsSchema(rtLists);
  }, []);
  if (!fields || !fields.text) {
    console.info('RichText component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RichText component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m09-rich-text",
    style: output ? center ? {
      textAlign: 'center'
    } : {} : {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(firstColumn ? '' : 'col-md-1')
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text ",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: textHidden ? 'rich-text--hidden' : ''
  }, pageEditing ? /*#__PURE__*/React.createElement(SitecoreRichText, {
    tag: "div",
    className: "rich-text__inner",
    field: fields && fields.text
  }) : /*#__PURE__*/React.createElement("div", {
    ref: richtextRef,
    className: "rich-text__inner height-fix",
    dangerouslySetInnerHTML: {
      __html: output
    },
    onClick: function onClick(e) {
      return tealiumCheckRightTextClick(e, tealiumMergeClickData(eventsAnalytics['richTextAnalytics'], params));
    }
  })), textHidden && /*#__PURE__*/React.createElement("div", {
    className: "rich-text__show-bar"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setTextHidden(false);
    }
  }, readMoreLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(firstColumn ? '' : 'col-md-1')
  })), componentListsSchema.map(function (listSchema) {
    return renderRTListSchema(listSchema);
  }));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className),
    "data-cy": "rich-text"
  }, children);
};
export var commonStyles = "c1j121nz";
export var ltrStyles = "l13zlhnl";
export var rtlStyles = "r1lnyela";
export default RichText;